import React, { useEffect, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import koLocale from "@fullcalendar/core/locales/ko";
import {
  Box,
  Paper,
  Typography,
  Grid,
  IconButton,
  Tooltip,
} from "@mui/material";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import { useGetTableData2 } from "../Plan/tableHooks";
import { useParams, useNavigate } from "react-router-dom";
import AssessmentIcon from "@mui/icons-material/Assessment";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import goToHelpLink from "../../../utils/goToHelpLink";

dayjs.locale("ko");

function PlanCalendar() {
  const { group_code, project_code } = useParams();
  const [events, setEvents] = useState([]);
  const navigate = useNavigate();
  const { data } = useGetTableData2(
    null,
    `/api/plan/generateCalendarEvt?group_code=${group_code}&project_code=${project_code}`
  );
  useEffect(() => {
    setEvents(data);
  }, [data]);
  const handleEventClick = (clickInfo) => {
    console.log("이벤트 클릭됨 - 무시");
  };
  const handleButtonClick = (dateStr) => {
    const isOverDay = events.filter(
      (i) => i.category === "over" && i.start === dateStr
    );
    if (isOverDay.length) {
      const selectedDate = dateStr;
      const machineKeys = isOverDay[0].keys.map((key) => Number(key));
      const searchParams = new URLSearchParams({
        date: selectedDate,
        machines: machineKeys.join(","),
      });
      navigate(
        `/plan/${group_code}/${project_code}/graph?${searchParams.toString()}`
      );
    }
  };
  // const handleDateClick = (dateInfo) => {
  //   console.log("날짜 클릭:", dateInfo.dateStr);
  //   handleButtonClick(dateInfo.dateStr); // 재사용
  // };
  // const handleDateSelect = (selectInfo) => {
  //   console.log("날짜 선택:", selectInfo.startStr);
  //   handleButtonClick(selectInfo.startStr); // 재사용
  // };
  const renderDayCell = (arg) => {
    const dateStr = dayjs(arg.date).format("YYYY-MM-DD");
    const isOverDay = events.filter(
      (i) => i.category === "over" && i.start === dateStr
    );
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "4px",
          width: "100%",
          color: "rgba(47, 43, 61, 0.68)",
        }}
      >
        <div>{arg.dayNumberText}</div>
        {isOverDay.length > 0 && (
          <Tooltip title="그래프로 확인하기">
            <IconButton
              size="small"
              onClick={() => handleButtonClick(dateStr)}
              sx={{ color: "#ff5c5c", cursor: "pointer" }}
            >
              <AssessmentIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </div>
    );
  };
  return (
    <Box sx={{ backgroundColor: "#f5f5f5", minHeight: "calc(100vh - 65px)" }}>
      <Grid container>
        {/* 헤더 */}
        <Grid item xs={12}>
          <Paper
            sx={{
              borderBottom: "1px solid var(--mui-palette-divider)",
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              sx={{ padding: "16px 24px" }}
            >
              <Box display="flex" alignItems="center" sx={{ height: "36px" }}>
                <Typography
                  variant="h5"
                  fontWeight={700}
                  sx={{ fontSize: "22px !important", color: "#111" }}
                >
                  생산 계획 캘린더
                </Typography>
                <Tooltip
                  title="이동"
                  sx={{ cursor: "pointer", marginLeft: "0.5rem" }}
                  onClick={() =>
                    goToHelpLink(
                      "http://esehelp.cafe24.com/planner#h-6-%EC%BA%98%EB%A6%B0%EB%8D%94-%ED%8E%98%EC%9D%B4%EC%A7%80"
                    )
                  }
                >
                  <HelpOutlineIcon />
                </Tooltip>
              </Box>
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Paper sx={{ p: 2, height: "100%", minHeight: "750px" }}>
            <Box
              sx={{
                p: 2,
                height: "100%",
                minHeight: "750px",
                "& .fc-daygrid-day-top": {
                  flexDirection: "row !important",
                },
                "& .fc-daygrid-day-frame": {
                  flexDirection: "row !important",
                },
                "& .fc-daygrid-day-events": {
                  flexDirection: "row !important",
                },
                "& .fc .fc-col-header-cell-cushion": {
                  color: "rgba(47, 43, 61, 0.68)",
                },
                // 만약 날짜 숫자와 이벤트가 함께 있는 컨테이너라면
                // "& .fc-daygrid-day": {
                //   "& > *": {
                //     flexDirection: "row !important",
                //   },
                // },
              }}
            >
              <FullCalendar
                plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                headerToolbar={{
                  left: "prev,next today",
                  center: "title",
                  right: "dayGridMonth,timeGridWeek,timeGridDay",
                }}
                initialView="dayGridMonth"
                locale={koLocale}
                events={events}
                eventClick={handleEventClick}
                // dateClick={handleDateClick}
                selectable={true}
                selectMirror={true}
                // select={handleDateSelect}
                dayMaxEvents={3}
                height="100%"
                dayCellContent={renderDayCell}
                eventContent={(eventInfo) => (
                  <Box sx={{ p: 0.5, overflow: "hidden" }}>
                    <Typography variant="caption" fontWeight="bold" noWrap>
                      {eventInfo.event.title}
                    </Typography>
                    <Typography
                      variant="caption"
                      display="block"
                      color="rgba(255,255,255,0.8)"
                    >
                      {eventInfo.event.extendedProps.type}
                    </Typography>
                  </Box>
                )}
                buttonText={{
                  today: "오늘",
                  month: "월",
                  week: "주",
                  day: "일",
                }}
              />
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}
export default PlanCalendar;
